import { RuleObject } from 'rc-field-form/lib/interface';
import { AdminVendorsData } from '@models/interfaces';

export const validateVendorEmail = (
  _: RuleObject,
  inputValue: string,
  vendors: AdminVendorsData[],
): Promise<void> => {
  if (!inputValue.trim()) {
    return Promise.resolve();
  }

  const isValid = vendors.some(vendor => vendor.email === inputValue);

  if (!isValid) {
    return Promise.reject(
      new Error("There aren't any vendors with such email!"),
    );
  }

  return Promise.resolve();
};
